export default "/images/vendor/flag-icon-css/flags/1x1/cg.svg?363fa0a518e3142cf3d601c8f28a797a";